import isIdentityVerified from "@/utils/isIdentityVerified";
import isExpiredUser from "@/utils/isExpiredUser";
import isPlayer from "@/utils/isPlayer";
import isPaidUser from "@/utils/isPaidUser";
import clientData from "@/services/clientData"

export const userType = Object.freeze({
    player: 1,
    coach: 2,
    clubStaff: 3,
    eventStaff: 7,
    free: 6,
})

class ClientUserData {
    get(path) {
        return clientData(path);
    }

    get gender() {
        return this.get('gender');
    }

    get siteId() {
        return this.get('siteId');
    }

    get userId() {
        return this.get('user_id');
    }

    get userType() {
        return this.get('user_type');
    }

    get isPlayer() {
        return isPlayer();
    }

    get isIdentityVerified() {
        return isIdentityVerified();
    }

    get isFreeUser() {
        return this.userType === userType.free;
    }

    get isPaidUser() {
        return isPaidUser();
    }

    get isExpiredUser() {
        return isExpiredUser();
    }

    get isClubStaff() {
        return this.userType === userType.clubStaff;
    }
}

export default new ClientUserData();